import styled from "styled-components";

export const TableVisualWrapper = styled.div`
	.card {
		margin: 0;
		border: 1px solid #e6e8ec;
		border-radius: 8px;
		box-shadow: none;
		overflow: hidden;
	}

	.card__title {
		display: none !important;
	}

	.ReactTable {
		border: 0;
		color: #30363d;
		font-size: 14px;
	}

	.ReactTable .rt-table {
		min-width: 980px;
	}

	.ReactTable .rt-thead {
		box-shadow: 0 2px 7px rgba(32, 39, 46, 0.08);
	}

	.ReactTable .rt-thead .rt-tr {
		min-height: 50px;
		background: #fff;
	}

	.ReactTable .rt-thead .rt-th {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		padding: 12px 10px;
		border-right: 1px solid #eceef1;
		color: #343a40;
		font-weight: 500;
		text-align: left;
	}

	.ReactTable .rt-thead .rt-th:last-child {
		justify-content: center;
		border-right: 0;
	}

	.ReactTable .rt-tbody {
		min-height: 80px;
	}

	.ReactTable .rt-tbody .rt-tr-group {
		border-bottom: 1px solid #eef0f2;
	}

	.ReactTable .rt-tbody .rt-tr {
		min-height: 68px;
		background: #fff !important;
	}

	.ReactTable .rt-tbody .rt-tr:hover {
		background: #fafbfc !important;
	}

	.ReactTable .rt-td {
		padding: 10px;
		border-right: 1px solid #f0f1f3;
		white-space: normal;
	}

	.ReactTable .rt-td:last-child {
		border-right: 0;
	}

	.ReactTable .-pagination {
		min-width: 800px;
		padding: 6px 8px;
		border-top: 1px solid #e6e8ec;
		box-shadow: none;
		background: #fff;
	}

	.ReactTable .-pagination .-previous,
	.ReactTable .-pagination .-next {
		flex: 1;
	}

	.ReactTable .-pagination .-btn {
		height: 38px;
		border-radius: 4px;
		background: #eeeeef;
		color: #555b61;
	}

	.ReactTable .-pagination .-btn:not([disabled]):hover {
		background: #e3e3e5;
		color: #373c42;
	}

	.ReactTable .-pagination .-center {
		flex: 1.5;
		gap: 16px;
	}

	.ReactTable .-pagination .-pageInfo {
		margin: 0;
		color: #33383d;
	}

	.ReactTable .-pagination .-pageJump input {
		width: 56px;
		height: 34px;
		border: 1px solid #d6d9de;
		border-radius: 4px;
	}

	.ReactTable .-pagination select {
		height: 36px;
		min-width: 108px;
		border: 1px solid #725cff;
		border-radius: 4px;
		background: #fff;
		color: #343a40;
	}

	@media (max-width: 1050px) {
		overflow-x: auto;
	}
`;

export const CellStack = styled.div`
	display: flex;
	flex-direction: column;
	gap: 4px;

	strong {
		color: #212529;
		font-size: 14px;
	}

	span {
		color: #6d757d;
		font-size: 12px;
	}
`;

export const StatusContent = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 4px;
	width: 100%;

	.badge {
		padding: 4px 8px;
		font-size: 10px;
	}
`;

export const PartnerName = styled.span`
	color: #6d757d;
	font-size: 12px;
`;

export const ActionContent = styled.div`
	display: flex;
	justify-content: center;
	width: 100%;
`;

export const ActionButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	border: 0;
	padding: 4px;
	background: transparent;
	color: #584c9c;
	cursor: pointer;

	&:hover {
		color: #30276f;
	}
`;

export const EmptyValue = styled.span`
	color: #7b8490;
`;

export const LinkText = styled.strong`
	color: #584c9c;
	cursor: pointer;

	&:hover {
		color: #30276f;
	}
`;
